// ─────────────────────────────────────────────
//  JiffyReview — shared data & constants
// ─────────────────────────────────────────────

export const PLATFORMS = [
  { id: "google",      name: "Google",      color: "#4285F4", icon: "G" },
  { id: "yelp",        name: "Yelp",        color: "#D32323", icon: "Y" },
  { id: "tripadvisor", name: "TripAdvisor", color: "#00AF87", icon: "T" },
  { id: "facebook",    name: "Facebook",    color: "#1877F2", icon: "f" },
];

export const QUICK_TAGS = [
  "Great service",
  "Friendly staff",
  "Clean & tidy",
  "Great value",
  "Would recommend",
  "Cozy atmosphere",
  "Quick service",
  "Delicious food",
];

export const NAV_ITEMS = [
  { id: "overview",  label: "Overview",   icon: "◈" },
  { id: "reviews",   label: "Reviews",    icon: "✦" },
  { id: "qr",        label: "QR & Print", icon: "⊞" },
  { id: "analytics", label: "Analytics",  icon: "∿" },
  { id: "settings",  label: "Settings",   icon: "⚙" },
];

// Sample reviews — replace with real Supabase data later
export const SAMPLE_REVIEWS = [
  {
    id: 1,
    name: "Sarah M.",
    stars: 5,
    text: "Absolutely loved it! The staff was warm and the food was exceptional.",
    time: "2 min ago",
    platform: "google",
    tags: ["Great service", "Delicious food"],
    photo: false,
    flagged: false,
  },
  {
    id: 2,
    name: "James T.",
    stars: 4,
    text: "Great experience for our anniversary dinner. The ambiance was perfect.",
    time: "47 min ago",
    platform: "yelp",
    tags: ["Cozy atmosphere"],
    photo: false,
    flagged: false,
  },
  {
    id: 3,
    name: "Priya K.",
    stars: 5,
    text: "Best brunch spot in the city. The avocado toast is genuinely unreal.",
    time: "1 hr ago",
    platform: "google",
    tags: ["Delicious food", "Great value"],
    photo: true,
    flagged: false,
  },
  {
    id: 4,
    name: "Marcus W.",
    stars: 2,
    text: "Waited 40 mins for our food. Staff seemed overwhelmed.",
    time: "3 hrs ago",
    platform: "google",
    tags: [],
    photo: false,
    flagged: true, // gated — private, not posted publicly
  },
  {
    id: 5,
    name: "Elena R.",
    stars: 5,
    text: "Came here for a work lunch and will definitely be back!",
    time: "5 hrs ago",
    platform: "tripadvisor",
    tags: ["Quick service", "Great value"],
    photo: false,
    flagged: false,
  },
];

// Demo business — replace with real logged-in merchant data later
export const DEMO_BUSINESS = {
  name: "The Rustic Table",
  location: "Austin, TX",
  emoji: "🍽️",
  date: "Mar 9, 2026",
  hasIncentive: true,
  incentiveCode: "THANKYOU10",
  incentiveValue: "10%",
  platforms: ["google", "yelp", "tripadvisor"],
};
